// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-socials__list[data-v-35e23154]{display:flex;grid-gap:var(--spaces-m);justify-content:center}@media(min-width:800px){.footer-socials__list[data-v-35e23154]{justify-content:flex-start}}.footer-socials__icon[data-v-35e23154]{width:20px;height:20px;color:var(--alert-grey-transparent-icon-color)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
